import { render, staticRenderFns } from "./DetailRewardCategory.vue?vue&type=template&id=5da9fc5d&scoped=true"
import script from "./DetailRewardCategory.vue?vue&type=script&lang=js"
export * from "./DetailRewardCategory.vue?vue&type=script&lang=js"
import style0 from "./DetailRewardCategory.vue?vue&type=style&index=0&id=5da9fc5d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da9fc5d",
  null
  
)

export default component.exports